/**
 * Notifications API client. Thin wrappers over the shared `apiFetch` helper (see
 * ./api) that map to the Elysia /notifications module. A user only ever sees and
 * mutates their OWN notifications (enforced server-side).
 */
import type { NotificationDto, Paginated, UnreadCountDto } from '@fc/core'
import { apiFetch } from './api'

export type { NotificationDto, UnreadCountDto } from '@fc/core'
export { NOTIFICATION_KIND_LABELS, type NotificationKind } from '@fc/core'

export interface ListNotificationsParams {
  page?: number
  pageSize?: number
  unreadOnly?: boolean
}

export const listNotifications = (
  params: ListNotificationsParams = {},
): Promise<Paginated<NotificationDto>> => {
  const search = new URLSearchParams()
  if (params.page) search.set('page', String(params.page))
  if (params.pageSize) search.set('pageSize', String(params.pageSize))
  if (params.unreadOnly) search.set('unreadOnly', 'true')
  const qs = search.toString()
  return apiFetch<Paginated<NotificationDto>>(`/notifications${qs ? `?${qs}` : ''}`)
}

export const getUnreadCount = (): Promise<UnreadCountDto> =>
  apiFetch<UnreadCountDto>('/notifications/unread-count')

export const markNotificationRead = (id: string): Promise<NotificationDto> =>
  apiFetch<NotificationDto>(`/notifications/${id}/read`, { method: 'POST' })

export const markAllNotificationsRead = (): Promise<UnreadCountDto> =>
  apiFetch<UnreadCountDto>('/notifications/read-all', { method: 'POST' })
